import { colors } from '@atlaskit/theme';
import styled from 'styled-components';

export const FlexGrow = styled.div`
  flex-grow: 1;
`;

export const RowHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  :not(:first-child) {
    margin-top: 40px;
  }
`;

export const RowHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  height: 22px;
`;

export const RowSubHeader = styled.div`
  margin-left: 16px;
  font-size: 12px;
  color: ${colors.N100};
`;

export const RowHeaderAction = styled.div`
  justify-self: flex-end;
`;
